export function createFavicon() {
    const link = document.createElement('link');
    link.setAttribute('type', 'image/x-icon');
    link.setAttribute('rel', 'icon');

    document.head.appendChild(link);

    return link;
}

export function getFavicon() {
    return document.querySelector<HTMLLinkElement>('link[rel="icon"]');
}

export function getFaviconHref() {
    const link = getFavicon();

    return link?.href || '';
}

export function setFaviconHref(href: string) {
    const link = getFavicon() ?? createFavicon();

    link.setAttribute('href', href);
}

export function getTitle() {
    return document.title;
}

export function setTitle(title: string) {
    document.title = title;
}
